import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "@auth/msalConfig";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { getApiOrigin } from "@utils/apiOrigin";
import { ensureFreshBundleBeforeRender } from "@hooks/useAppVersionCheck";
import { redirectLegacyHashRoute } from "@utils/legacyHashRedirect";

// Drop legacy service workers from older builds so they cannot serve stale app shells.
if (typeof window !== "undefined" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (const registration of registrations) {
        void registration.unregister();
      }
    });
  });
}

// Expose API base URL to window for legacy scripts in public folder
if (typeof window !== 'undefined') {
  (window as any).REACT_APP_API_BASEURL = getApiOrigin();
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const googleClientId =
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  "119002168133-pctle9eerm7i04kqe0s0aa5m2q3305mn.apps.googleusercontent.com";

async function bootstrap() {
  redirectLegacyHashRoute();
  await ensureFreshBundleBeforeRender();

  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <MsalProvider instance={msalInstance}>
          <GoogleOAuthProvider clientId={googleClientId}>
            <App />
          </GoogleOAuthProvider>
        </MsalProvider>
      </Provider>
    </React.StrictMode>
  );
}

void bootstrap();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
